import PitchStrikeZoneLocation from "./PitchStrikeZoneLocation.js";

// see visualization @ https://docs.google.com/document/d/1GCQVVh6Ue0DrSiaHLYZ4zasDBxZSEi6kYt1aHgD_afo/edit#heading=h.xd2nn5xtjjdb
const strikeZoneSector  = {
    // IN THE ZONE
    // TODO - map pitch location zones... waiting for Cobus
    1:  { key: "1",     name: "Zone 1",     isInZone: true, zoneLocation: PitchStrikeZoneLocation.TopLeft },
    2:  { key: "2",     name: "Zone 2",     isInZone: true },
    3:  { key: "3",     name: "Zone 3",     isInZone: true },
    4:  { key: "4",     name: "Zone 4",     isInZone: true },
    5:  { key: "5",     name: "Zone 5",     isInZone: true },
    6:  { key: "6",     name: "Zone 6",     isInZone: true },
    7:  { key: "7",     name: "Zone 7",     isInZone: true },
    8:  { key: "8",     name: "Zone 8",     isInZone: true },
    9:  { key: "9",     name: "Zone 9",     isInZone: true },
    // out, no strict matching 
    11:  { key: "11",     name: "Zone 11",     isInZone: false },
    12:  { key: "12",     name: "Zone 12",     isInZone: false },
    13:  { key: "13",     name: "Zone 13",     isInZone: false },
    14:  { key: "14",     name: "Zone 14",     isInZone: false },
};

export default strikeZoneSector;